import request from '@/utils/request'

export function getOrderList(data) {
  return request.post('/purchase-order/list', data)
}

export function addOrder(data) {
  return request.post('/purchase-order/add', data)
}

export function modifyOrder(data) {
  return request.post('/purchase-order/modify', data)
}

export function deleteOrder(data) {
  return request.post('/purchase-order/delete', data)
}

export function modifyOrderStatus(data) {
  return request.post('/purchase-order/modify-status', data)
}

export function completeOrder(data) {
  return request.post('/purchase-order/complete', data)
}

export function approveOrder(data) {
  return request.post('/purchase-order/approve', data)
}



// WEBPACK FOOTER //
// ./src/api/purchase/order.js